import { supabase } from "@/integrations/supabase/client";

export interface Stats {
  readCount: number;
  likeCount: number;
}

export class ArticleStatsService {
  static async fetchStats(articleId: string): Promise<Stats> {
    try {
      const { data, error } = await supabase
        .from("article_stats")
        .select("read_count, like_count")
        .eq("article_id", articleId)
        .single();

      if (error || !data) {
        if (error) console.error("Error loading article stats", error);
        return { readCount: 0, likeCount: 0 };
      }

      return {
        readCount: data.read_count ?? 0,
        likeCount: data.like_count ?? 0,
      };
    } catch (err) {
      console.error("Error fetching article stats", err);
      return { readCount: 0, likeCount: 0 };
    }
  }

  static async incrementReadCount(articleId: string, userId?: string): Promise<void> {
    try {
      const { error } = await supabase.rpc('increment_article_read_count', {
        article_slug: articleId,
        user_uuid: userId || null
      });
      
      if (error) {
        console.error("Error incrementing read count", error);
      }
    } catch (err) {
      console.error("Failed to increment read count", err);
    }
  }

  static async toggleLike(articleId: string, userId: string): Promise<boolean> {
    try {
      const { data, error } = await supabase.rpc('toggle_article_like', {
        article_slug: articleId,
        user_uuid: userId
      });
      
      if (error) {
        console.error("Error toggling like", error);
        return false;
      }
      
      return data as boolean;
    } catch (err) {
      console.error("Failed to toggle like", err);
      return false;
    }
  }

  static async checkUserLiked(articleId: string, userId: string): Promise<boolean> {
    try {
      const { data, error } = await supabase
        .from("user_article_interactions")
        .select("has_liked")
        .eq("article_id", articleId)
        .eq("user_id", userId)
        .maybeSingle();
      
      if (error) {
        console.error("Error checking like status", error);
        return false;
      }
      
      return data?.has_liked ?? false;
    } catch (err) {
      console.error("Failed to check like status", err);
      return false;
    }
  }
}
